<template>
  <v-container fluid>
    <v-toolbar flat class="mb-3">
      <v-toolbar-title>{{ cliente.nombre }}</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-container>
      <div v-if="loader">
        <v-skeleton-loader
          class="mx-auto"
          type="list-item-avatar-three-line"
        ></v-skeleton-loader>
      </div>
      <div v-else>
        <pdf src="./path/to/static/relativity.pdf"></pdf>
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="cliente.nombre"
                label="Razón social"
                readonly
                prepend-icon="mdi-account"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="cliente.rfc"
                label="RFC"
                readonly
                prepend-icon="mdi-account"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="cliente.correo"
                label="Correo"
                readonly
                prepend-icon="mdi-account"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="cliente.telefono"
                label="Celular de Contacto"
                readonly
                prepend-icon="mdi-cellphone-basic"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="cantidad_guias"
                label="Folios Disponibles"
                readonly
                prepend-icon="mdi-cube-send"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="cliente.contrasena"
                ref="txtContrasena"
                label="Contreseña"
                :readonly="!modificar_formulario"
                prepend-icon="mdi-form-textbox-password"
                :type="show_password ? 'text' : 'password'"
                :append-outer-icon="
                  modificar_formulario ? 'mdi-content-save' : 'mdi-account-edit'
                "
                @click:append-outer="modificar()"
                :loading="loading_modificar"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </v-container>
    <v-dialog v-model="dialog_mensaje" max-width="320">
      <v-card>
        <v-card-title class="text-h5 text-center">
          {{ titulo }}
        </v-card-title>

        <v-card-text>
          {{ mensaje }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialog_mensaje = false">
            Entendido
          </v-btn>

          <v-btn color="green darken-1" text @click="dialog_mensaje = false">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import service from "@/core/Servicio.js";
export default {
  data: () => ({
    cantidad_guias: 0,
    show_password: false,
    loader: true,
    modificar_formulario: false,
    dialog_mensaje:false,
    titulo:"",
    mensaje:"",
    loading_modificar: false,
    cliente: {
      nombre: localStorage.getItem("nombre"),
      correo: localStorage.getItem("correo"),
      rfc: localStorage.getItem("rfc"),
      direccion: localStorage.getItem("direccion"),
      telefono: localStorage.getItem("telefono"),
      contrasena: localStorage.getItem("contrasena"),
    },
  }),
  created() {
    this.initialize();
  },
  methods: {
    modificar() {
      //Validamos si estamos guardando o edittando
      if (this.modificar_formulario) {
        this.loading_modificar = true;
        let params = {
          cliente_id: localStorage.getItem("id"),
          contrasena: this.cliente.contrasena,
        };
        service
          .modificarCliente(params)
          .then((response) => {
            this.loading_modificar = false;
            if (response.data.response_flag == 1) {
              //Modificamos en localstorage
              localStorage.setItem("contrasena", this.cliente.contrasena);
              this.modificar_formulario = false;
              this.show_password = false;
              this.dialog_mensaje = true;
              this.titulo = "Correcto";
              this.mensaje = "Se modificado correctamente la contraseña";
            }else{
              this.dialog_mensaje = true;
            this.titulo = "Problemas";
            this.mensaje = "Hubo un error en el servidor, contactar a encargado de sitio";
            }
          })
          .catch(() => {
            console.log("Error");
            this.dialog_mensaje = true;
            this.titulo = "Problemas";
            this.mensaje = "Hubo un error en el servidor, contactar a encargado de sitio";
          });
      } else {
        this.modificar_formulario = true;
        this.show_password = true;
        this.$refs.txtContrasena.focus();
      }
    },
    initialize() {
      let params = {
        cliente_id: localStorage.getItem("id"),
      };
      service
        .consultarFolios(params)
        .then((response) => {
          this.loader = false;
          if (response.data.response_flag == 1) {
            this.cantidad_guias = response.data.response.guias_disponibles;
            //window.open("http://192.168.64.131:8000/311021083308.pdf", 'download_window');
          }
        })
        .catch(() => {
          console.log("Error");
        });
    },
  },
};
</script>
